import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import styles from "./BottomNav.module.css";
import { useIsFreeTrial } from "../../hooks/useUser";

import StoreIcon from "./icons/BSM_Store_Icon.svg";
import ListIcon from "./icons/My_Lists_Icon.svg";
import OrdersSvg from "./icons/MyOrdersIcon.svg";
import CartSvg from "./icons/Cart_Icon.svg";

export function BottomNav({ cartCount = 0, activePath }) {
  const history = useHistory();
  const location = useLocation();
  const isFreeTrial = useIsFreeTrial();

  const path = activePath || location.pathname;

  const activeKey = (() => {
    if (path.startsWith("/order")) return "my-orders";
    if (path.startsWith("/my-orders")) return "my-orders";
    if (path.startsWith("/wwg-store")) return "wwg-store";
    if (path.startsWith("/my-lists")) return "my-lists";
    if (path.startsWith("/cart")) return "cart";
    return "";
  })();

  return (
    <div className={styles.bottomNav}>
      <button
        className={`${styles.navItem} ${
          activeKey === "wwg-store" ? styles.active : ""
        }`}
        onClick={() => history.push("/wwg-store")}
      >
        <span className={styles.iconWrap}>
          <img src={StoreIcon} alt="WWG Store" className={styles.icon} />
        </span>
        <span className={styles.label}>WWG Store</span>
      </button>

      <button
        className={`${styles.navItem} ${
          activeKey === "my-lists" ? styles.active : ""
        }`}
        onClick={() => history.push("/my-lists")}
      >
        <span className={styles.iconWrap}>
          <img src={ListIcon} alt="My Lists" className={styles.icon} />
        </span>
        <span className={styles.label}>My Lists</span>
      </button>

      {!isFreeTrial && (
        <button
          className={`${styles.navItem} ${
            activeKey === "my-orders" ? styles.active : ""
          }`}
          onClick={() => history.push("/my-orders")}
        >
          <span className={styles.iconWrap}>
            <img src={OrdersSvg} alt="My Orders" className={styles.icon} />
          </span>
          <span className={styles.label}>My Orders</span>
        </button>
      )}

      {!isFreeTrial && (
        <button
          className={`${styles.navItem} ${
            activeKey === "cart" ? styles.active : ""
          }`}
          onClick={() => history.push("/cart")}
        >
          <span className={styles.iconWrap}>
            <img src={CartSvg} alt="Cart" className={styles.icon} />
            {cartCount > 0 && (
              <span className={styles.cartBadge}>
                {cartCount > 99 ? "99+" : cartCount}
              </span>
            )}
          </span>
          <span className={styles.label}>Cart</span>
        </button>
      )}
    </div>
  );
}
